import { themeAlpine } from "ag-grid-community";
import { useSelector } from "react-redux";
import { getTheme } from "../redux/themeSlice";

const useAgGridTheme = (variant: string | null | undefined) => {
  // Get the theme from Redux store
  const theme = useSelector(getTheme) as any;

  // Define AG Grid theme with theme properties
  const spTheme = themeAlpine.withParams({
    accentColor: theme.typography.color,
    browserColorScheme: "light",
    checkboxBorderWidth: 2,
    iconSize: 16,
    checkboxCheckedBackgroundColor: theme.palette.secondary.main,
    checkboxCheckedBorderColor: theme.palette.secondary.main,
    checkboxCheckedShapeColor: theme.palette.primary.contrastText,
    checkboxIndeterminateBackgroundColor: theme.palette.secondary.main,
    checkboxIndeterminateBorderColor: theme.palette.secondary.main,
    checkboxUncheckedBorderColor: theme.palette.secondary.main,
    columnBorder: false,
    fontFamily: {
      googleFont: theme.typography.fontFamily,
    },
    foregroundColor: theme.typography.color,
    headerFontSize: 14,
    headerBackgroundColor: theme.palette.secondary.main,
    invalidColor: theme.palette.primary.hover,
    valueChangeDeltaDownColor: theme.palette.primary.main,
    valueChangeDeltaUpColor: theme.palette.secondary.main,
    valueChangeValueHighlightBackgroundColor: theme.palette.primary.hover,
    widgetContainerHorizontalPadding: 12,
    widgetContainerVerticalPadding: 12,
    widgetHorizontalSpacing: 12,
    wrapperBorderRadius: 8,
    ...(variant === "compact" && {
      rowBorder: false,
      rowVerticalPaddingScale: 0.4,
      selectCellBackgroundColor: "#FFFFFF",
      selectCellBorder: false,
      selectedRowBackgroundColor: "#FFFFFF",
    }),
  });

  return spTheme;
};

export default useAgGridTheme;
